"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _splitNode2 = _interopRequireDefault(require("../node/splitNode"));
var _splitNodes = _interopRequireDefault(require("../node/splitNodes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line import/no-cycle

var assingChildren = R.assoc('children');
var getTop = R.pathOr(0, ['box', 'top']);
var getChildren = R.propOr([], 'children');
var splitChildren = function splitChildren(height, contentArea, node) {
  var children = getChildren(node);
  var availableHeight = height - getTop(node);
  return (0, _splitNodes.default)(availableHeight, contentArea, children);
};
var splitView = function splitView(node, height, contentArea) {
  var _splitNode = (0, _splitNode2.default)(node, height),
    currentNode = _splitNode[0],
    nextNode = _splitNode[1];
  var _splitChildren = splitChildren(height, contentArea, node),
    currentChilds = _splitChildren[0],
    nextChildren = _splitChildren[1];
  var next = assingChildren(nextChildren)(nextNode);
  if (next !== null && next !== void 0 && next.children.length) {
    return [assingChildren(currentChilds)(currentNode), next];
  }
  return [assingChildren(currentChilds)(currentNode), null];
};
var _default = exports.default = splitView;